import React from 'react'
import { Panel } from 'rsuite'
import OrdersWithProduct from '../form/order/OrdersWithProduct'
import type { GQL_ID } from '@@partner:types:graphql'

export interface ProductOrdersTabProps {
  productId: GQL_ID
}

export default function ProductOrdersTab ({
  productId
}: ProductOrdersTabProps) {
  return (
    <Panel shaded header="Заказы с этим товаром" className="my-5">
      <OrdersWithProduct productId={productId} />
    </Panel>
  )
}
